import React from 'react';

export default class Preference extends React.Component {
  render() {
    return <div className="content">
      <h1 className="title is-3">My Preference</h1>
      <img src="/assets/images/step+5.jpeg" />
      <p>Preference for a treatment follows a careful review of the potential risks and benefits of each option presented on the menu of reasonable choices.  </p>
      <p>Clinicians can provide a balanced summary of risks and benefits.  Your review of risks should include the most common adverse effects.  A more comprehensive listing can be found in the package insert that comes with prescription medications.</p>
      <p>Preferences may also be influenced by time considerations.  Make sure your care provider is aware of your time constraints (e.g. I can't risk being sleepy during exam period, I want the treatment that is most likely to work before I need to go back to work). </p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/Preference.js